import React from 'react';

export const UserPersonInfoContext = React.createContext();